import { useContext } from 'react';
import { EditorContext } from '../context/EditorContextValue';

// AI-CONTEXT: Shown by data widgets whose source (output/effect/vraag/quote/...)
// is not selected, or no longer resolves — e.g. after a template copy, when the
// widget still points at the template tenant's data. Deliberately minimal: just
// a dark pill CTA. Outside the editor (viewer / public report) it renders
// nothing, so unconfigured widgets stay invisible to readers.

/**
 * Empty-source CTA for live-report data widgets. Editor-only: the click
 * bubbles to the canvas node, which selects the widget and opens its
 * settings panel.
 *
 * @param {object} props
 * @param {string} props.ctaLabel - Button label, e.g. "Selecteer output"
 */
const WidgetSourcePlaceholder = ({ ctaLabel }) => {
    const editorCtx = useContext(EditorContext);

    if (!editorCtx || !ctaLabel) {
        return null;
    }

    return (
        <div className="widget-source-placeholder">
            <button className="wsp-cta" type="button">
                <span className="wsp-cta-plus" aria-hidden="true">+</span>
                {ctaLabel}
            </button>
        </div>
    );
};

export default WidgetSourcePlaceholder;
